module.exports = __webpack_public_path__ + "static/media/qAtmosphereInfo4.028cf2fe.webp";